import { useEffect, useState } from "react";
import { BuyButton } from "./BuyButton";

interface BuyButtonData {
  insights_event_action?: string;
  insights_event_category?: string;
  insights_event_label?: string;
  insights_event_tealium_event?: string;
  track: string;
}

interface QuoteDetailsFormProps {
  buyButtonData: BuyButtonData;
  formAuthenticityToken: string;
  insurer: string;
  quoteId: string;
  journeyToken: string;
  buttonLabel: string;
}

export const QuoteDetailsForm = ({
  buyButtonData,
  formAuthenticityToken,
  insurer,
  quoteId,
  journeyToken,
  buttonLabel,
}: QuoteDetailsFormProps) => {
  const [action, setAction] = useState("");

  useEffect(() => {
    setAction(document.location.toString());
  }, []);

  return (
    <form action={action} method="post">
      <input
        type="hidden"
        name="journey_token"
        data-testid="journey_token"
        value={journeyToken}
      />
      <input
        type="hidden"
        name="authenticity_token"
        data-testid="authenticity_token"
        value={formAuthenticityToken}
      />
      <input
        type="hidden"
        name="insurer"
        data-testid="insurer"
        value={insurer}
      />
      <input
        type="hidden"
        name="quote_id"
        data-testid="quote_id"
        value={quoteId}
      />
      <input
        type="hidden"
        name="buy_button_clicked"
        data-testid="buy_button_clicked"
        value="yes"
      />
      <BuyButton buyButtonData={buyButtonData} buttonLabel={buttonLabel} />
    </form>
  );
};
